import React, {useContext, useEffect, useState} from "react";
import {
  Divider,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import {AppContext} from "../../context/AppContext";
import {loadNFts, loadPortfolioItems, mintNft} from "../../utils/functions";
import {toast} from "react-toastify";
import {auth} from "../../config/firebase";
import {TemplateRow} from "./components/PortfolioTableItem";
import {ViewNftModal} from "./components/ViewNftModal";
import {handleArchiveLicense} from "../../utils/archiveLicense";
import useConfirm from "../../hooks/useConfirm";
import {TemplateTable} from "./components/TemplateTable";
import {TemplateAccordion} from "./components/TemplateAccordion";
import {useLocation, useSearchParams} from "react-router-dom";

export const Portfolio = () => {
    const {state: {royaltyTemplates, licenseTemplates}, dispatch} = useContext(AppContext);
    const [selectedNft, setSelectedNft] = useState(null);
    const [status, setStatus] = useState(null);
    const [DeleteDialog, confirmDelete] = useConfirm("Are you sure you want to delete this license?", "Once a license is deleted, it cannot be recovered. You are responsible for any losses that might occur.")
    const [ArchiveDialog, confirmArchive] = useConfirm("Are you sure you want to archive this license?", "Archiving will disable the Share URL and public view, which can prevent anyone else from accepting the license.\n\nYou’ll still be able to view archived licenses in your portfolio.")
    const [searchParams, setSearchParams] = useSearchParams();
    const openNftUid = searchParams.get("nftUid");


    useEffect(() => {
      if (openNftUid && (royaltyTemplates?.length > 0 || licenseTemplates?.length > 0)) {
        // console.log(openNftUid);
        const royaltyTemplate = royaltyTemplates?.find(i => i?.uid === openNftUid);
        const licenseTemplate = licenseTemplates?.find(i => i?.uid === openNftUid || i?.nftUid === openNftUid);
        console.log(licenseTemplates)
        if (royaltyTemplate || licenseTemplate) {
          console.log("NFT", royaltyTemplate || licenseTemplate)
          setSelectedNft(royaltyTemplate || licenseTemplate || null);
          searchParams.delete("nftUid");
        }
        setSearchParams(searchParams); // this updates the URL
      }
    }, [openNftUid, royaltyTemplates, licenseTemplates]);

    useEffect(() => {
        if (selectedNft && royaltyTemplates?.length) {
            const selected = royaltyTemplates?.find(template => template?.uid === selectedNft?.uid);
            setSelectedNft(selected || null);
        }
    }, [royaltyTemplates, selectedNft, auth.currentUser])

    async function tryMintingAgain(nftData) {
        toast.info("Attempting to mint...")
        const updatedNft = await mintNft(nftData.publicWalletAddress, nftData.uid, null, setStatus, nftData)
        if (updatedNft) {
            const royaltyTemplatesWithRemovedNft = royaltyTemplates.filter(template => template.uid !== nftData.uid)
            console.log('dispatching')
            dispatch({type: "update_royalty_templates", payload: [...royaltyTemplatesWithRemovedNft, updatedNft]});
            //refresh the page
            
            toast.success("NFT minted")
        } else {
            toast.error("Error minting NFT, try again later")
        }
    }

    const handleViewDocument = (template) => {
        setSelectedNft(template);
    }

    const handleArchive = async (license, nft) => {
        try {
            const handleSuccess = (newLicense, newNft) => {
                const items = royaltyTemplates?.map(item => {
                  if (item?.uid === newNft?.uid) {
                    return {...newNft};
                  }
                  return {...item};
                });
                dispatch({type: "update_royalty_templates", payload: items});
                toast.success(`License ${newLicense?.archive ? "archived" : "unarchived"} successfully`)
            }
            const response = await confirmArchive();
            if (response) {
              await handleArchiveLicense({license, nft, handleSuccess});
            }
        } catch (error) {
            console.log(error);
            toast.error("Failed to Archive license")
        }
    }

    const handleDelete = async (license, nft) => {
      try {
        const handleSuccess = (newNft) => {
          const items = royaltyTemplates?.map(item => {
            if (item?.uid === newNft?.uid) {
              return {...newNft};
            }
            return {...item};
          });
          dispatch({type: "update_royalty_templates", payload: items});
          toast.success(`License deleted successfully`)
        }
        const handleSignedLicense = async (license, nft) => {
          try {
            console.log("HANDLE SIGNED LICENSE")
            const handleSuccess = (newLicense, newNft) => {
              const items = royaltyTemplates?.map(item => {
                if (item?.uid === newNft?.uid) {
                  return {...newNft};
                }
                return {...item};
              });
              dispatch({type: "update_royalty_templates", payload: items});
              toast.success(`License ${newLicense?.archive ? "archived" : "unarchived"} successfully`)
            }
            const response = await confirmArchive("We’re sorry, this license cannot be deleted.", "We can’t delete a license has already been accepted.\n\nConsider archiving the license. Archiving will disable the Share URL and public view, which can prevent anyone else from accepting the license.");
            console.log(response);
            if (response) {
              await handleArchiveLicense({license, nft, handleSuccess});
            }
          } catch (error) {
            console.log(error);
            toast.error("Failed to Archive license")
          }
        };

        const response = await confirmDelete();
        if (response) {
          // await handleDeleteLicense({license, nft, handleSuccess, handleSignedLicense});
        }
      } catch (error) {
        console.log(error);
        toast.error("Failed to Delete license")
      }
    }


    return (
        <>
            <DeleteDialog />
            <ArchiveDialog />
            <ViewNftModal
                open={!!selectedNft}
                handleClose={() => setSelectedNft(null)}
                nft={selectedNft}
            />
            <Stack
                direction={"row"}
                gap={2}
                maxWidth={"lg"}
                sx={{px: 2, width: "100%", mx: {xs: "", sm: "auto"} }}
                alignItems={"center"}
                justifyContent={"space-between"}
            >
                <Typography
                    sx={{
                        textAlign: "center",
                        fontWeight: 700,
                        fontSize: "2rem",
                        color: "#2D2D30"
                    }}
                >
                    Portfolio
                </Typography>
            </Stack>
            <Stack direction={"column"} gap={2} maxWidth={"lg"} sx={{mx: "auto", width: "90%", my: 5}}>
              <TemplateAccordion title={"My NFTs"} description={"This section showcases all the NFTs you have personally created. Whether they're digital assets, collectibles, or other unique templates, you can manage them from here. If you haven’t created any yet, start by minting your first NFT."}>
                <TemplateTable
                  templates={royaltyTemplates?.filter(item => item?.userUid === auth.currentUser.uid)}
                  emptyListText="No templates available yet. Start by creating a new one!"
                  handleDelete={handleDelete} handleArchive={handleArchive} onMint={tryMintingAgain} handleViewDocument={handleViewDocument}
                />
              </TemplateAccordion>
              <Divider />
              <TemplateAccordion title={"My Licenses"} description={"Here, you’ll find NFTs that you’ve licensed—assets that you’ve acquired or have permission to use. This section allows you to view and manage your licensed NFTs effortlessly. If you don’t have any yet, consider exploring licensed NFT opportunities."}>
                <TemplateTable
                  templates={licenseTemplates}
                  emptyListText="No licenses available yet. Start by creating a new one!"
                  handleDelete={handleDelete} handleArchive={handleArchive} onMint={tryMintingAgain} handleViewDocument={handleViewDocument}
                />
              </TemplateAccordion>
            </Stack>

        </>
    )
}
